import { useServerSideFilters } from "@/hooks/useQueryFilters";
import {
  InvoiceSmbReviewStatus,
  InvoiceType,
} from "@/lib/constants/invoiceStatus";
import { useMemo } from "react";
import { useInvoiceLiveCountsSubscription } from "../live-counts";

export const useCompanyPayableInvoicesToReviewLiveCountsSubscription = () => {
  const query = useMemo(() => {
    const baseQuery = {
      type: [InvoiceType.PAYABLE],
      smbReviewStatus: [InvoiceSmbReviewStatus.UNREVIEWED],
    };

    return baseQuery;
  }, []);

  const serverSideQuery = useServerSideFilters({ query });

  const { liveCounts, loading } = useInvoiceLiveCountsSubscription({
    query: serverSideQuery,
  });

  return { liveCounts, loading };
};
